import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    let validatorLat = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Bạn chưa nhập vĩ độ'))
      } else {
        callback()
      }
    }
    let validatorLng = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Bạn chưa nhập kinh độ'))
      } else {
        callback()
      }
    }
    let validatorCity = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Bạn chưa chọn thành phố'))
      } else {
        callback()
      }
    }
    let validatorDistrict = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Bạn chưa chọn quận huyện'))
      } else {
        callback()
      }
    }
    return {
      localPostOffice: {
        name: '',
        phone: '',
        code: '',
        city_id: '',
        district_id: '',
        carrier_id: '',
        address: '',
        lat: 0,
        lng: 0
      },
      rules: {
        name: [
          {required: true, message: 'Bạn chưa nhập tên bưu cục', trigger: 'change'},
          {min: 5, max: 255, message: 'Tên bưu cục phải trong khoảng 5 đến 255 ký tự', trigger: 'change'}
        ],
        phone: [
          {required: true, message: 'Bạn chưa nhập số điện thoại', trigger: 'change'},
          {min: 8, max: 12, message: 'Số điện thoại phải trong khoảng 8 đến 12 ký tự', trigger: 'change'}
        ],
        code: [
          {min: 3, max: 10, message: 'Mã bưu cục  phải trong khoảng 3 đến 10 ký tự', trigger: 'change'}
        ],
        city_id: [
          {validator: validatorCity, trigger: 'change'}
        ],
        district_id: [
          {validator: validatorDistrict, trigger: 'change'}
        ],
        carrier_id: [
          {required: true, message: 'Bạn chưa chọn hãng vận chuyển', trigger: 'change'}
        ],
        lat: [
          {validator: validatorLat, trigger: 'change'}
        ],
        lng: [
          {validator: validatorLng, trigger: 'change'}
        ]
      },
      submitting: false
    }
  },
  computed: {
    ...mapGetters('city', ['cities']),
    ...mapGetters('district', ['districts']),
    ...mapGetters('carrier', ['carriers'])
  },
  methods: {
    ...mapActions('city', ['getAllCity']),
    ...mapActions('district', ['getAllDistrict']),
    ...mapActions('carrier', ['getAllCarriers']),
    getDistrict () {
      this.localPostOffice.district_id = ''
      this.getAllDistrict({city_id: this.localPostOffice.city_id, limit: -1, sort: 'name:1'})
    },
    newPostOffice () {
      this.localPostOffice = {
        name: '',
        phone: '',
        code: '',
        city_id: '',
        district_id: '',
        carrier_id: '',
        address: '',
        lat: 0,
        lng: 0
      }
    }
  },
  mounted () {
    this.newPostOffice()
    if (!this.carriers.length) {
      this.getAllCarriers({limit: -1})
    }
    if (!this.cities.length) {
      this.getAllCity({limit: -1, sort: 'name:1'})
    }
  },
  watch: {
    localPostOffice: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/postOffice/mixins/index.js